module.exports = __webpack_public_path__ + "assets/97c4e0b0ca84d15b1b539e929a5ee344.mp3";